import { Box } from '@mui/material'
import dayjs from 'dayjs'
import { memo, ReactElement, useMemo } from 'react'
import { useAppSelector } from '../../redux/hook'
import {
    defaultLocalization,
    getDateTimeUserFormate,
} from '../../utils/DateAndTimeUtils'
import { getSelectedTimezoneLabel } from '../../utils/TimezoneOptions'
import TruncatedText from './TruncatedText'

interface IValueDisplayBox {
    dataValue: any
    fontSize?: string
    showTimezone?: boolean
}

const DatetimeTypeData = ({
    dataValue,
    fontSize,
    showTimezone = true,
}: IValueDisplayBox): ReactElement => {
    const userLocalization = useAppSelector(
        (state) => state.user.user?.preferences?.localization,
    )

    const effectiveLocalization = userLocalization || defaultLocalization

    const formattedValue = useMemo(() => {
        if (!dataValue?.datetime) return ''

        const timezone =
            dataValue.timezone ||
            effectiveLocalization?.timeZone ||
            dayjs.tz.guess()

        const baseDate = getDateTimeUserFormate(
            dataValue.datetime,
            `${effectiveLocalization?.dateFormat} ${effectiveLocalization?.timeFormat}`,
            timezone,
        )

        const tzLabel = getSelectedTimezoneLabel(timezone)

        return showTimezone ? `${baseDate} ${tzLabel}` : baseDate
    }, [dataValue, effectiveLocalization, showTimezone])

    return (
        <Box sx={{ width: '100%' }}>
            <TruncatedText
                sx={fontSize ? { fontSize } : undefined}
                text={formattedValue}
            />
        </Box>
    )
}

const MemoizedDatetimeTypeData = memo(DatetimeTypeData)
MemoizedDatetimeTypeData.displayName = 'DatetimeTypeData'
export default MemoizedDatetimeTypeData
